controllers.controller('HostedPageWindowController', [
    '$scope', '$state', '$filter', '$timeout', '$ionicLoading', '$q', '$sce', 'LocaleService', 'config', 'Validator',
    'Storage', 'constants', 'ServerTimeService', 'Utils', 'UserService', 'API', 'ErrorService', '$window', '$cookies',
    function ($scope, $state, $filter, $timeout, $ionicLoading, $q, $sce, LocaleService, config, Validator, Storage,
              Const, ServerTimeService, Utils, UserService, API, ErrorService, $window, $cookies) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.user = UserService.get();
        $scope.paymentMethods = Storage.get('paymentMethods') || [];
        $scope.showAmountSelect = true;
        $scope.depositValue = Storage.get('depositValue');
        $scope.validator = Validator.getPattern;
        $scope.methodName = $state.params.method.name || '';
        $scope.pspCurrencies = $state.params.method.pspCurrencies || [];
        $scope.pspCurrency = $scope.pspCurrencies.length > 0 ? $scope.pspCurrencies[0] : null;
        $scope.config = {
            min: $scope.depositValue.minimum,
            max: $scope.depositValue.maximum,
            visual: $scope.depositValue.visual,
            digits: 0,
            step: 50,
            listAmounts: [],
            pspCurrencies: $scope.pspCurrencies
        };

        $scope.urlReady = false;

        var result = [];

        Array(5).fill(null).reduce(function (acc, cur, index) {
            var tmp = Math.ceil(acc * Const.depositMultipliers[index]);
            result.push(tmp);
            return tmp;
        }, $scope.config.visual <= $scope.config.min ? $scope.config.min : $scope.config.visual);

        if (result.length > 0) $scope.config.listAmounts = result;

        $scope.amount = {
            value: $scope.config.visual,
            pspCurrency: $scope.pspCurrency
        };

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        $scope.getUrl = function () {
            return doPayment();
        };

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'HostedPageController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        function doPayment() {
            var request = {
                amount: parseInt($scope.amount.value, 10),
                pspCurrency: $scope.amount.pspCurrency || undefined,
                pspName: Const.paymentMethodsBlueprint[$state.params.method.name] || $state.params.method.name,
                remarketing: $cookies.get('remarketing') || ''
            };

            $ionicLoading.show();

            return API.hostedPageDeposit(request)
                .then(checkResponse)
                .then(function (response) {
                    if (response && response.RedirectURL) {
                        $ionicLoading.hide();
                        $window.open(response.RedirectURL, '_self', 'hardwareback=no,location=0,menubar=0,closebuttoncaption=Back,hidden=yes');
                        return $state.go('root.app.assets');
                    }
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.isError = true;
                    $scope.modal.textTitle = LocaleService.translation.messages.general_error;
                    $scope.modal.textContent = LocaleService.translation.messages.general_error_text;
                    $scope.modal.actionText = $scope.paymentMethods.length > 1 ? LocaleService.translation.try_again : LocaleService.translation.close;
                    $scope.modal.back = $scope.paymentMethods.length > 1 ? 'root.app.wallet' : 'root.app.assets';
                    $scope.modal.state = true;
                })
        }

        function clear() {
            $scope.user = null;
        }

        $scope.$on('$ionicView.beforeEnter', function () {
            if($state.params.method.hasOwnProperty("amountRequired") && !$state.params.method.amountRequired)  {
                $scope.showAmountSelect = false;
                $scope.amount.value = 1;
                doPayment();
            }
        });

        $scope.$on('$ionicView.afterLeave', clear);
        $scope.$on('clear', clear);
    }
]);
